import React, { ReactNode } from 'react';
import classNames from 'classnames';
import { css } from '@emotion/react';
import { ButtonProps } from './Button';
import { motion } from 'framer-motion';
import { button_base_css, accordion_button_css, accordion_button_size_css } from './styles';
import { IconArrowChevronDown } from '../icons/generated';
import { semantic_colors } from '../../foundation';
import { Stack } from '../stack';
import { AccordionButtonSize } from './types';

export interface AccordionButtonProps
  extends Omit<ButtonProps, 'fill' | 'loading' | 'kind' | 'startIcon' | 'endIcon' | 'size'> {
  /** @default 'medium' */
  size?: AccordionButtonSize;
  /** Label 좌측 렌더링될 Addon 요소 */
  leftAddon?: ReactNode;
  /** Label 우측 화살표 오픈 상태 여부 */
  opened?: boolean;
  /**
   * 너비 100% 사용 여부
   */
  fill?: boolean;
}

const ArrowMotion = motion(Stack);

export const AccordionButton = React.forwardRef<HTMLButtonElement, AccordionButtonProps>(
  (
    { size = 'medium', leftAddon, opened, children, type = 'button', disabled, className, fill = false, ...props },
    ref,
  ) => {
    return (
      <button
        type={type}
        className={classNames('pds-button', className)}
        css={[
          button_base_css,
          accordion_button_css,
          accordion_button_size_css[size],
          css`
            ${fill && 'width: 100%;'}
            cursor: ${disabled ? 'not-allowed' : 'pointer'};
          `,
        ]}
        disabled={disabled}
        {...props}
        ref={ref}
      >
        <Stack direction='row' gap={4} align='center'>
          {leftAddon}
          {children}
        </Stack>
        <ArrowMotion
          animate={{
            rotate: opened ? 180 : 0,
          }}
          transition={{ duration: 0.25 }}
        >
          <IconArrowChevronDown color={semantic_colors.content.tertiary} />
        </ArrowMotion>
      </button>
    );
  },
);
